import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ActionCoCalculatorService } from "../../action-co/action-co-card/action-co-services/action-co-calculator.service";
import { BodisplayModule, BoPropertyInlineModule, DynamicTagGroupModule, DynamicTagModule } from "../../bodisplay";
import { ConditionModule } from "../../conditions";
import { InsertDocModule } from "../../insertdoc";
import { PipeModule } from "../../pipes";
import { CalculatorCalculComponent } from "./calculator-calcul/calculator-calcul.component";
import { CalculatorConfigComponent, FilterObligation, FilterProperty } from "./calculator-config/calculator-config.component";
import { CalculatorViewComponent } from "./calculator-view/calculator-view.component";
import { CalculatorComponent } from "./mission-calculator.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    PipeModule,
    BodisplayModule,
    DynamicTagModule,
    DynamicTagGroupModule,
    BoPropertyInlineModule,
    InsertDocModule,
    ConditionModule,
    ScrollingModule,
  ],
  declarations: [
    CalculatorComponent,
    CalculatorViewComponent,
    CalculatorConfigComponent,
    CalculatorCalculComponent,
    FilterObligation,
    FilterProperty
  ],
  exports: [
    CalculatorComponent
  ],
  providers: [
    ActionCoCalculatorService,
  ],
})
export class MissionCalculatorModule { }
